export default __webpack_public_path__ + "static/slider-bckg-d086eae101bbd623db6175f55862882b.webp";